import { BlankSlate } from "@msuite/ui/blank-slate";
import { Droppable, getDroppablePayload } from "@msuite/ui/dnd";
import { ConfirmModal, ModalWrapper, useAsyncModal } from "@msuite/ui/modal";
import { queries } from "@msuite/zero";
import { useZeroQuery } from "@msuite/zero/react";
import React from "react";
import {
	type TicketAssignmentType,
	type TicketType,
	useCrewHandler,
} from "@/sites/plan/plan-kanban/use-crew-handler";
import { useDailyContext } from "../daily/context";
import { useCrewContext } from "./context";
import { TicketAssignment } from "./ticket-assignment";

export function CrewTickets() {
	/** Context */
	const { canArrangeTicketOf } = useDailyContext();
	const { crewId, planId } = useCrewContext();

	const crewHandler = useCrewHandler({ crewId, planId });

	/** Hooks */
	const asyncModal = useAsyncModal();
	const [assignments] = useZeroQuery(queries.ticketAssignments.byCrewId({ crewId }));

	/** Render */
	return (
		<React.Fragment>
			<Droppable
				className="flex flex-col gap-0 col-span-2 h-max crew-projects"
				accept={["ticket", "ticket-assignment"]}
				handleOnDrop={(element) => {
					const payload = getDroppablePayload(element);
					if (payload.type === "ticket-assignment") {
						crewHandler.onDropTicketAssignment(payload.item as TicketAssignmentType);
					} else if (payload.type === "ticket") {
						crewHandler.onDropTicket(payload.item as TicketType);
					}
				}}
				isDisabled={!!assignments?.length}
				// Accepting a ticket here is arranging its project's work — the fixed rule, asked
				// against the dragged item, because the empty lane has no project of its own. The
				// published lock and the guest board's blanket refusal ride inside the answer.
				canDrop={(data) => {
					const payload = getDroppablePayload(data);
					const item = payload.item as { projectId?: string };
					return !!item.projectId && canArrangeTicketOf(item.projectId);
				}}
			>
				{assignments?.map((assignment) => {
					return (
						<TicketAssignment
							key={assignment.id}
							assignment={assignment}
						/>
					);
				})}
				<BlankSlate
					withAccessory={false}
					className="py-1"
				/>
			</Droppable>
			<ModalWrapper>
				{asyncModal.isOpen && (
					<ConfirmModal
						controller={asyncModal}
						message="help"
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
